var set = require('regenerate')(0x10C7, 0x10CD, 0x2D27, 0x2D2D);

set.addRange(0x10A0, 0x10C5).addRange(0x10D0, 0x10FA).addRange(0x10FC, 0x10FF).addRange(0x1C90, 0x1CBA).addRange(0x1CBD, 0x1CBF).addRange(0x2D00, 0x2D25);
module.exports = set;